// @flow
import {BatchInbox} from '@batch.com/react-native-plugin';
import {Platform} from 'react-native';
import {call, put, select, takeEvery} from 'redux-saga/effects';
import {tripica} from '../../api';
import {setLoading} from '../LoadingStatus';
import type {NotificationAction} from './actions';
import {setPushNotifications, setTriPicaNotifications} from './actions';
// import config from '../../config';
import HandleErrorService from '../../lib/handleError';
import I18n from '../../lib/i18n';
import {
  customerDeviceIdSelector,
  customerExternalIdSelector,
} from '../Customer/selectors';
import WizzeeLog from '../../lib/wizzeeLog';

export function* fetchNotificationsSaga(
  action: NotificationAction,
): Generator<*, *, *> {
  if (action.type !== 'FETCH_NOTIFICATIONS') return; // flow

  const {refresh, hideErrors} = action.payload;

  try {
    if (refresh) {
      yield put(setLoading('fetchNotifications', true));
    }
    // TO-FIX the "fetchNotificationsForUserIdentifier" method seems to no longuer be supported
    // https://doc.batch.com/cordova/advanced/4x-migration/#inbox
    // if (config.isBatchInboxEnabled && !__DEV__) {
    //   yield call(fetchPushNotificationsSaga, { ...action, type: 'FETCH_PUSH_NOTIFICATIONS' });
    // } else {
    yield call(fetchTriPicaNotificationsSaga, {
      ...action,
      type: 'FETCH_TRIPICA_NOTIFICATIONS',
    });
    // }
  } catch (error) {
    WizzeeLog.warn('[fetchNotificationsSaga] ', error);
    if (!hideErrors) {
      HandleErrorService.showToastError(error, () =>
        I18n.t('Dashboard.Notifications.unableToFetch'),
      );
    }
  } finally {
    if (refresh) {
      yield put(setLoading('fetchNotifications', false));
    }
  }
}

export function* fetchTriPicaNotificationsSaga(
  action: NotificationAction,
): Generator<*, *, *> {
  if (action.type !== 'FETCH_TRIPICA_NOTIFICATIONS') return; // flow

  const notifications = yield call([tripica, 'getNotifications']);
  yield put(setTriPicaNotifications(notifications));
}

export function* fetchPushNotificationsSaga(
  action: NotificationAction,
): Generator<*, *, *> {
  if (action.type !== 'FETCH_PUSH_NOTIFICATIONS') return; // flow

  const externalId = yield select(customerExternalIdSelector);
  const deviceId = yield select(customerDeviceIdSelector);

  const authKey = yield call(
    [tripica, 'getBatchInboxAuthenticationKey'],
    Platform.OS,
    externalId,
  );

  const notifications = yield call(
    [BatchInbox, 'fetchNotificationsForUserIdentifier'],
    deviceId,
    authKey,
  );

  yield put(
    setPushNotifications(
      notifications.map(({date, payload, ...notification}) => ({
        ...notification,
        notificationDate: date != null ? Number(date) : null,
        type: payload?.eventName || null,
      })),
    ),
  );
}

export function* getPaymentAuthenticationNotificationByProductOrderOuid(
  productOrderOuid: string,
): Generator<*, *, *> {
  const notifications = yield call([tripica, 'getNotifications']);
  const paymentAuthentNotification = notifications.find(
    notification =>
      notification.type === 'PAYMENT_AUTHENT_REQUIRED' &&
      notification.parameters.orderOuid === productOrderOuid,
  );

  return paymentAuthentNotification;
}

export default function* (): Generator<*, *, *> {
  yield* [takeEvery('FETCH_NOTIFICATIONS', fetchNotificationsSaga)];
}
